"use client";

import { MarkDownView } from "@anthology/shared/src/components";

const source = `# Terms & Conditions

These Terms & Conditions ("Terms") govern your access to and use of the Slinky content management system and music distribution platform ("Slinky," "we," "us," or "our"). By accessing or using Slinky, you confirm that you accept these Terms and agree to be bound by them. If you do not accept these Terms, please select "Decline" and discontinue use of the platform.

## 1. Acceptance of Terms

    1.1 Agreement and Acceptance
   By registering on Slinky's website, you confirm that you have reviewed and understand these Terms, along with our Privacy Policy and other policies referenced here. This Agreement becomes effective upon your acceptance of these Terms.

    1.2 Who We Are
   Slinky is a smart link platform operated by Absolute Label Services Ltd, headquartered at Hill Place House, 55a High Street, Wimbledon Village, London, SW19 5BA.

## 2. Definitions

The following definitions apply throughout these Terms:

* **Agreement**: This document, including any related policies or agreements between you and Slinky.
* **Digital Distribution**: Distribution, licensing, or other authorized digital delivery of Recordings through online channels and platforms chosen by Slinky.
* **Outlets**: The platforms, such as digital retailers, streaming services, and collection societies, where Slinky distributes content.
* **Product Uploader**: Slinky's toolset and software for uploading files to the platform.
* **Properties**: The Recordings and related assets, including artwork and metadata, provided by you to Slinky for distribution.
* **Recordings**: Audio or audiovisual files of high quality, as determined by Slinky, that are submitted by you for distribution.
* **Talent**: Individuals involved in creating or contributing to the Properties, such as artists and producers.
* **Term**: The period during which this Agreement remains effective, beginning upon acceptance and continuing until terminated.
* **Territory**: The global market, unless otherwise specified by you on a recording-by-recording basis.

## 3. Distribution Rights and Services

    3.1 Assignment of Identifiers
   Slinky may assign industry-standard identifiers at your request, such as ISRCs and UPCs, to your Recordings to facilitate tracking and distribution.

    3.2 Promotion and Use of Artwork
   You grant Slinky and the designated Outlets the right to use the artwork, names, and promotional materials you provide to promote your content effectively.

## 4. Client Obligations

    4.1 Content Compliance
   You agree that all Properties uploaded to Slinky must comply with our standards and the content requirements of third-party platforms (e.g., Spotify, Apple Music). We may request adjustments to your Properties to ensure compliance with these standards.

    4.2 Clearances for Third-Party Content
   You are solely responsible for securing all third-party rights, permissions, and clearances necessary to distribute your Properties through Slinky, including permissions from sample owners and contributors. Any failure to secure these rights may lead to withheld royalties or content removal.

    4.3 Prevention of Fraud
   You agree not to engage in fraudulent activities or artificially manipulate streaming data or other metrics. Any such activity may result in withheld royalties, removal of Properties, or termination of this Agreement.

## 5. Payment and Accounting

    5.1 Distribution Share
   Slinky will pay you a share of net receipts received from digital distribution as detailed in your client agreement.

    5.2 Withholdings and Deductions
   We may withhold or deduct fees, taxes, and other amounts as required by law or by the platforms where your Properties are distributed.

## 6. Limitation of Liability

    6.1 No Guarantee of Results
   Slinky makes no guarantees regarding earnings, specific placements, or distribution outcomes. You acknowledge and accept the speculative nature of content distribution.

## 7. Representations and Warranties

    7.1 Ownership and Rights
   You represent that you hold all necessary rights to distribute the Properties through Slinky and have secured all required licenses and permissions.

    7.2 Compliance with Laws
   You agree to comply with all applicable laws, including data protection laws such as GDPR, and acknowledge that Slinky will not be responsible for legal non-compliance on your part.

## 8. Indemnification

You agree to defend, indemnify, and hold harmless Absolute Label Services, its affiliates, and representatives against any claims, damages, or expenses arising from a breach of this Agreement or any third-party claims related to the Properties.

## 9. Confidentiality

You agree to maintain the confidentiality of any proprietary information obtained about Slinky's systems, operations, or business practices through your use of the platform, except as required by law.

## 10. Governing Law and Dispute Resolution

    10.1 Jurisdiction
   These Terms are governed by the laws of England and Wales. Both parties agree to submit to the exclusive jurisdiction of the UK courts.

## 11. Force Majeure

Slinky is not liable for delays or failure to perform due to uncontrollable events such as natural disasters, technical failures, or other unforeseen disruptions.

## 12. Survival of Terms

Provisions on confidentiality, liability, indemnification, and payment obligations will survive the termination of this Agreement.

## 13. Updates to Terms & Conditions

We reserve the right to update these Terms, with changes communicated through the client portal. For significant changes, you may be required to re-accept the Terms.

## Contact Us

For any questions regarding these Terms, please contact us:

Email: dpo@absolutelabelservices.com`;

const Page = () => {
  return <MarkDownView source={source} />;
};

export default Page;
